module.exports = __webpack_public_path__ + "img/text.563898c.svg";